import React from 'react';
import { Link } from 'react-router-dom';
import style from './Header.module.scss';
import logoMark from '../imgs/yesterday-stories-logo.png';
import ProfileMenu from './ProfileMenu';

const Header = ({ user, setShow, onSignOut }) => (
    <header className={style.header}>
        <div className={`wrap ${style.nav}`}>
            <Link to="/" className={style.logo} onClick={() => window.scrollTo(0, 0)}>
                <img src={logoMark} alt="Yesterday Stories" className={style.logoMark} />
                Yesterday Stories
            </Link>
            <nav className={style.navLinks}>
                <Link to="/#how-it-works">How it works</Link>
                <Link to="/#stories">Stories</Link>
                <Link to="/#trails">Trails</Link>
                <Link to="/#do">Create</Link>
                <Link to="/schools">Schools</Link>
            </nav>
            <div className={style.navActions}>
                {user ? (
                    <ProfileMenu onLogout={onSignOut} />
                ) : (
                    <button
                        type="button"
                        className={style.authLink}
                        onClick={() => setShow && setShow("flex")}
                    >
                        Sign In / Register
                    </button>
                )}
                <Link to="/#about" className={style.navCta}>Get the app</Link>
            </div>
        </div>
    </header>
);

export default Header;
